module.exports = __webpack_public_path__ + "img/CIO110&200&210&300.9891a692.png";